// Super admin module route url.
export const AUTH = '/auth';
export const LOGIN = AUTH + '/login';

export const DASHBOARD = '/dashboard';
export const ID = `id`;

export const ROLE = '/role';

export const SUPER_ADMIN = '/admin';

export const USER = '/users';
export const USER_FORM = USER + '/userform';
export const USER_FORM_ID = USER + '/edit-user/:userId';
export const PRODUCT = '/product';
export const PRODUCT_FORM = PRODUCT + '/productform';
export const PRODUCT_FORM_ID = PRODUCT + '/edit-product';
export const SUBSIDY_CALCULATION = '/subsidy-calculation';
export const optionId = 'optionId';

export const GROUP_MANAGEMENT = '/group-management';
export const GROUP_MANAGEMENT_FORM = '/group-management/form';

export const APPLICATION_TYPE = '/application-type';
export const APPLICATION_TYPE_FORM = '/application-type/form';
export const APPLICATION_TYPE_ID = '/application-type/edit-form';
export const APPLICATION_TYPE_OPTION = '/application-request-option';
export const APPLICATION_TYPE_OPTION_FORM = APPLICATION_TYPE_OPTION + '/form';
export const APPLICATION_TYPE_OPTION_ID =
  APPLICATION_TYPE_OPTION + `/edit-option/:optionId`;
export const APPLICATION = '/application';
export const OVERVIEW = APPLICATION + '/overview';
export const EVENT = '/event';
export const EVENT_FORM = EVENT + '/eventform';
export const EVENT_ID = EVENT + '/edit-event';
export const TOOLTIP = '/tooltip';
export const ROLE_MATRIX = '/role';
export const ROLE_MATRIX_FORM = ROLE_MATRIX + '/form';
export const ROLE_MATRIX_FORM_ID = '/role/edit-form/:editRoleId';
export const SUBSIDY_CALCULATION_WITH_INCOME =
  SUBSIDY_CALCULATION + '/with-income';
export const SUBSIDY_CALCULATION_WITHOUT_INCOME =
  SUBSIDY_CALCULATION + '/without-income';
export const SUBSIDY_CALCULATION_WITH_INCOME_CALCULATOR =
  SUBSIDY_CALCULATION + '/household-income-calculation';
export const HEALTH_APPLICATION_CALCULATION =
  SUBSIDY_CALCULATION + '/health-application-calculation';
export const SMTP_CONFIG = '/mail';
export const ADMIN_LEVEL = '/admin-level';
export const ADMIN_LEVEL_FORM = ADMIN_LEVEL + '/form';
export const ADMIN_LEVEL_FORM_ID = '/admin-level/edit-form/:editAdminLevelId';
export const FEDERAL_STATE = '/federal-state';
export const FEDERAL_STATE_FORM = FEDERAL_STATE + '/form';
export const PAGE_NOT_FOUND = '/404';
export const CONFIGURATION = '/configuration';
export const LOGS = '/logs';
export const FAQ = '/faq/questions';
export const FAQ_DOC_1 = '/faq/user-guide';
export const FAQ_DOC_2 = '/faq/admin-guide';
